<template>
    <div>
        <MenuProducts/>
        <Product_Close/>
    </div>
</template>

<script>
    import MenuProducts from "@/components/admin/manage_products/menuproducts/MenuProducts.vue";
    import Product_Close from "@/components/admin/manage_products/Product_Close.vue";
    export default {
        name: "ProductClose",
        components: {
            Product_Close,
            MenuProducts
        }
    }
</script>

<style scoped>

</style>
